import { createContext, useContext } from "react";

import { MenuSettingsState } from "features/MenuSettings/hooks/useMenuSettingsState";

export const MenuSettingsContext = createContext<MenuSettingsState | null>(null);

export const useMenuSettingsContext = (): MenuSettingsState => {
    const context = useContext(MenuSettingsContext);
    if (!context) {
        throw new Error("useMenuSettingsContext должен использоваться внутри MenuSettings");
    }
    return context;
};
